<!-- {{ usuario.typ_name }} -->
<div class="col-md-12">
    <br>
    <div class="minititulo">
        Videoconsulta
    </div>
    <div class="titulo">
        Mis salas de espera
    </div>
    <br>
</div>


<!-- <div *ngIf="usuario.typ_name == 'MEDICO'" class="row">
    <div class="card col-md-12" *ngIf="consultas.length > 0">
        <div class="card-body bordeCardBeneficiario">
            <div class="flex-row comment-row">
                <div *ngIf="consultas.length > 0">
                    <div *ngIf="usuario.typ_name == 'MEDICO'" style="overflow-x:auto;">
                        <table class="table">
                            <thead
                                style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 24px; color: #171994;">
                                <tr>
                                    <th>Paciente</th>
                                    <th>Rut</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Consulta</th>
                                </tr>
                            </thead>
                            <tbody style="font-family: Mulish; font-size: 20px;color: #3F3F3F">
                                <tr *ngFor="let item of consultas" ngDefaultControl>
                                    <td>{{item.nombre_paciente}} {{item.apellido_paterno_paciente}}
                                        {{item.apellido_materno_paciente}}</td>
                                    <td>{{item.rut_paciente}}</td>
                                    <td>{{item.fecha_consulta| date:'dd-MM-yyyy'}}</td>
                                    <td>{{item.hora}}</td>
                                    <td><button class="btn btn-outline-primary btn-lg botonModalAgregar"
                                            style="border-radius: 40px; font-size: 18px; color: #ffffff; font-weight: bold;"
                                            (click)="unirseReunionDoctor(item)">Ir a la Consulta</button></td>
                                </tr>

                            </tbody>
                        </table>

                        <br><br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="col-md-12 p-0" *ngIf="usuario.typ_name == 'MEDICO'" style="overflow-x:auto; padding: 0 !important;">
    <div class="card "
        [ngClass]="{'bordeCardBeneficiario': item.tel_doc_app_boo_is_ondemand == false, 'borderCardOndemand': item.tel_doc_app_boo_is_ondemand == true}"
        style="margin-top: 20px;" *ngFor="let item of consultas">
        <div class="card-body p-3">
            <section>
                <!-- Títulos para escritorio -->
                <div class="d-none d-lg-flex row text-center" style="font-weight: bold; color: #555;">
                    <div class="col-lg-3">Paciente</div>
                    <div class="col-lg-2">Rut</div>
                    <div class="col-lg-2">Fecha</div>
                    <div class="col-lg-2">Hora</div>
                    <div class="col-lg-3 col-md-12">Consulta</div>
                </div>

                <!-- Línea separadora -->
                <hr class="d-none d-lg-block" style=" margin: 10px 0;"
                [ngStyle]="{'border': item.tel_doc_app_boo_is_ondemand ? '1px solid #2BABB7' : '1px solid #316AD8'}">

                <!-- Datos en formato tabla para escritorio -->
                <div class="d-none d-lg-flex row text-center">
                    <div class="col-lg-3" style="display: flex; justify-content: center; align-items: center;">
                        {{item.nombre_paciente}} {{item.apellido_paterno_paciente}}
                        {{item.apellido_materno_paciente}}
                    </div>
                    <div class="col-lg-2" style="display: flex; justify-content: center; align-items: center;">
                        {{item.rut_paciente}}</div>
                    <div class="col-lg-2" style="display: flex; justify-content: center; align-items: center;">
                        {{item.fecha_consulta | date:'dd-MM-yyyy'}}</div>
                    <div class="col-lg-2" style="display: flex; justify-content: center; align-items: center;">
                        {{item.hora}}</div>
                    <div class="col-lg-3 col-md-12"
                        style="display: flex; justify-content: center; align-items: center;">
                        <button
                            style="border-radius: 20px; border: none; padding: 10px 20px; font-weight: bold; color: white"
                            [ngStyle]="{'background-color': item.tel_doc_app_boo_is_ondemand ? '#2BABB7' : '#316AD8'}"
                            (click)="unirseReunionDoctor(item)">
                            Ir a la Consulta
                        </button>
                    </div>
                </div>

                <!-- Diseño para dispositivos móviles -->
                <div class="d-block d-lg-none">
                    <div class="row">
                        <div class="col-5 text-left font-weight-bold">Médico:</div>
                        <div class="col-7 text-right">{{item.nombre_doctor}} {{item.apellido_paterno_doctor}}
                            {{item.apellido_materno_doctor}}</div>
                    </div>
                    <div class="row">
                        <div class="col-5 text-left font-weight-bold">Especialidad:</div>
                        <div class="col-7 text-right">{{item.spe_name}}</div>
                    </div>
                    <div class="row">
                        <div class="col-5 text-left font-weight-bold">Fecha:</div>
                        <div class="col-7 text-right">{{item.fecha_consulta | date:'dd-MM-yyyy'}}</div>
                    </div>
                    <div class="row">
                        <div class="col-5 text-left font-weight-bold">Hora:</div>
                        <div class="col-7 text-right">{{item.hora}}</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 text-center">
                            <button
                                style="border-radius: 20px; border: none; padding: 10px 20px; font-weight: bold; color: white"
                                [ngStyle]="{'background-color': item.tel_doc_app_boo_is_ondemand ? '#2BABB7' : '#316AD8'}"
                                (click)="unirseReunionDoctor(item)">
                                Ir a la Consulta
                            </button>



                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div *ngIf="usuario.typ_name == 'MEDICO'">
    <div *ngIf="consultas.length > 0" class="row">
        <div class="col-md-12 card-alerta" *ngIf="consultas.length == 0">
            <table>
                <tr>
                    <td><mat-icon style="color:#171994;font-size: 30px;margin: 20px 40px 10px;">info</mat-icon> </td>
                    <td>
                        <p class="letras-alerta" style="margin: 20px 5px 10px; font-weight: bold;">No tienes consultas
                            para el día de hoy</p>
                    </td>

                </tr>
            </table>
        </div>
    </div>
</div>
<div *ngIf="usuario.typ_name == 'PACIENTE'">
    <div *ngIf="consultas.length > 0" class="row">
        <div class="col-md-12 card-alerta" *ngIf="consultas.length == 0">
            <table>
                <tr>
                    <td><mat-icon style="color:#171994;font-size: 30px;margin: 20px 40px 10px;">info</mat-icon> </td>
                    <td>
                        <p class="letras-alerta" style="margin: 20px 5px 10px; font-weight: bold;">No tienes consultas
                            para el día de hoy</p>
                    </td>

                </tr>
            </table>
        </div>
    </div>
</div>

<!-- paciente -->

<div class="col-md-12 p-0" *ngIf="usuario.typ_name == 'PACIENTE' && consultaOndemand.tel_doc_od_id"
    style="overflow-x:auto;">
    <div class="card borderCardOndemand" style="margin-top: 20px;" *ngIf="tiempoEspera.consulta.sta_id !== 116">
        <div class="card-body p-3">
            <section>
                <!-- Diseño para pantallas grandes -->
                <div class="d-none d-lg-block">
                    <!-- Títulos -->
                    <div class="row text-center font-weight-bold" style="color: #555;">
                        <div class="col-lg-3">Especialidad</div>
                        <div class="col-lg-6">Fecha y hora de ingreso a la fila</div>
                        <div class="col-lg-3">Consulta</div>
                    </div>

                    <!-- Línea separadora -->
                    <hr style="border: 1px solid #2BABB7; margin: 10px 0;">

                    <!-- Datos en formato tabla -->
                    <div class="row text-center">
                        <div class="col-lg-3" style="display: flex; justify-content: center; align-items: center;">{{
                            consultaOndemand.spe_name }}</div>
                        <div class="col-lg-6" style="display: flex; justify-content: center; align-items: center;">{{
                            consultaOndemand.fechaIn }} - {{ consultaOndemand.horaIn }}</div>
                        <div class="col-lg-3" style="display: flex; justify-content: center; align-items: center;">
                            <button
                                style="border-radius: 20px; background-color: #2BABB7; border: none; padding: 10px 20px; font-weight: bold; color: white"
                                (click)="unirseConsultaOndemand()">
                                {{textoBoton}}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Diseño para dispositivos móviles -->
                <div class="d-block d-lg-none">
                    <div class="row">
                        <div class="col-5 font-weight-bold">Especialidad:</div>
                        <div class="col-7 text-right">{{ consultaOndemand.spe_name }}</div>
                    </div>
                    <div class="row">
                        <div class="col-5 font-weight-bold">Fecha y Hora:</div>
                        <div class="col-7 text-right">{{ consultaOndemand.fechaIn }} - {{ consultaOndemand.horaIn }}
                        </div>
                    </div>
                    <div class="row mt-2 text-center">
                        <div class="col-12">
                            <button
                                style="border-radius: 20px; background-color: #2BABB7; border: none; padding: 10px 20px; font-weight: bold; color: white"
                                (click)="unirseConsultaOndemand()">
                                Ir a la sala de espera
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div class="col-md-12 p-0" *ngIf="usuario.typ_name == 'PACIENTE'" style="overflow-x:auto;">
    <div class="card bordeCardBeneficiario" style="margin-top: 20px;"
    [ngClass]="{'bordeCardBeneficiario': item.tel_doc_app_boo_is_ondemand == false, 'borderCardOndemand': item.tel_doc_app_boo_is_ondemand == true}"
    *ngFor="let item of consultas">
    
        <div class="card-body p-3">
            <section>
                <!-- Títulos para escritorio -->
                <div class="d-none d-lg-flex row text-center" style="font-weight: bold; color: #555;">
                    <div class="col-lg-3">Médico</div>
                    <div class="col-lg-2">Especialidad</div>
                    <div class="col-lg-2">Fecha</div>
                    <div class="col-lg-2">Hora</div>
                    <div class="col-lg-3 col-md-12">Consulta</div>
                </div>

                <!-- Línea separadora -->
                <hr class="d-none d-lg-block" style=" margin: 10px 0;"
                [ngStyle]="{'border': item.tel_doc_app_boo_is_ondemand ? '1px solid #2BABB7' : '1px solid #316AD8'}">

                <!-- Datos en formato tabla para escritorio -->
                <div class="d-none d-lg-flex row text-center">
                    <div class="col-lg-3" style="display: flex; justify-content: center; align-items: center;">
                        {{item.nombre_doctor}} {{item.apellido_paterno_doctor}}
                        {{item.apellido_materno_doctor}}</div>
                    <div class="col-lg-2" style="display: flex; justify-content: center; align-items: center;">
                        {{item.spe_name}}</div>
                    <div class="col-lg-2" style="display: flex; justify-content: center; align-items: center;">
                        {{item.fecha_consulta | date:'dd-MM-yyyy'}}</div>
                    <div class="col-lg-2" style="display: flex; justify-content: center; align-items: center;">
                        {{item.hora}}</div>
                    <div class="col-lg-3 col-md-12"
                        style="display: flex; justify-content: center; align-items: center;">
                        <button
                            style="border-radius: 20px; background-color: #316ad8; border: none; padding: 10px 20px; font-weight: bold; color: white"
                            [ngStyle]="{'background-color': item.tel_doc_app_boo_is_ondemand ? '#2BABB7' : '#316AD8'}"
                            (click)="unirseReunionPaciente(item)">
                            Ir a la sala de espera
                        </button>
                    </div>
                </div>

                <!-- Diseño para dispositivos móviles -->
                <div class="d-block d-lg-none">
                    <div class="row">
                        <div class="col-5 text-left font-weight-bold">Médico:</div>
                        <div class="col-7 text-right">{{item.nombre_doctor}} {{item.apellido_paterno_doctor}}
                            {{item.apellido_materno_doctor}}</div>
                    </div>
                    <div class="row">
                        <div class="col-5 text-left font-weight-bold">Especialidad:</div>
                        <div class="col-7 text-right">{{item.spe_name}}</div>
                    </div>
                    <div class="row">
                        <div class="col-5 text-left font-weight-bold">Fecha:</div>
                        <div class="col-7 text-right">{{item.fecha_consulta | date:'dd-MM-yyyy'}}</div>
                    </div>
                    <div class="row">
                        <div class="col-5 text-left font-weight-bold">Hora:</div>
                        <div class="col-7 text-right">{{item.hora}}</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 text-center">
                            <button
                                style="border-radius: 20px; background-color: #316ad8; border: none; padding: 10px 20px; font-weight: bold; color: white"
                                (click)="unirseReunionPaciente(item)">
                                Ir a la sala de espera
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>







<!--<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-8 col-xs-12">
                            <h3 style="font-size: 28px; font-weight: bold; color: #5cd6ff" >Mi Sala de Espera</h3>
                        </div>
                    </div>
                </div>
            <div *ngIf="consultas.length > 0">

                <div *ngIf="usuario.typ_name == 'PACIENTE'">
                    <div class="card-body">
                        <table class="table">
                            <thead style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 24px; color: #171994;">
                                <tr>
                                    <th>Medico</th>
                                    <th>Especialidad</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Consulta</th>
                                </tr>
                            </thead>
                            <tbody style="font-size: 20px;color: #000000">

                                     <th scope="row">15</th> 
                                    <tr *ngFor="let item of consultas" ngDefaultControl>
                                        <td>{{item.nombre_doctor}} {{item.apellido_paterno_doctor}} {{item.apellido_materno_doctor}}</td>
                                        <td>{{item.spe_name}}</td>
                                        <td>{{item.fecha_consulta| date:'dd-MM-yyyy'}}</td>
                                        <td>{{item.hora}}</td>
                                        <td><button *ngIf="item.tel_doc_app_boo_sta_id==30" class="btn btn-outline-primary" 
                                                    style="border-radius: 40px; font-size: 18px; color: #ffffff; font-weight: bold;"
                                                    (click)="unirseReunionPaciente(item)">Unirse a la Consulta</button>
                                            <button *ngIf="item.tel_doc_app_boo_sta_id==10" class="btn btn-outline-primary" 
                                                    style="border-radius: 40px; font-size: 18px; color: #ffffff; font-weight: bold;"
                                                    (click)="ConfirmarAsistencia(item)">Confirmar Asistencia</button>
                                        </td>
                                    </tr>

                            </tbody>
                        </table>

                        <br><br>
                    </div>
                </div>





                <div *ngIf="usuario.typ_name == 'MEDICO'">
                    <div class="card-body">
                        <table class="table">
                            <thead style="font-size: 20px; font-weight: bold; color: #000000">
                                <tr>
                                    <th>Paciente</th>
                                    <th>Rut</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Consulta</th>
                                </tr>
                            </thead>
                            <tbody style="font-size: 20px;color: #000000">

                                    <!-- <th scope="row">15</th> 
                                    <tr *ngFor="let item of consultas" ngDefaultControl >
                                        <td>{{item.nombre_paciente}} {{item.apellido_paterno_paciente}} {{item.apellido_materno_paciente}}</td>
                                        <td>{{item.rut_paciente}}</td>
                                        <td>{{item.fecha_consulta| date:'dd-MM-yyyy'}}</td>
                                        <td>{{item.hora}}</td>
                                        <td><button class="btn btn-outline-primary" 
                                                    style="border-radius: 40px; font-size: 18px; color: #ffffff; font-weight: bold;"
                                                    (click)="unirseReunionDoctor(item)">Ver la Consulta</button></td>
                                    </tr>

                            </tbody>
                        </table>

                        <br><br>
                    </div>
                </div>
            </div>

            <div *ngIf="consultas.length == 0">
                <p>No tiene consultas para este día</p>
            </div>

            </div>
        </div>
    </div>
</div> -->

<!--
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-8 col-xs-12">
                            <h3 style="font-size: 28px; font-weight: bold; color: #5cd6ff">Mis Reuniones Grupales</h3>
                        </div>
                    </div>
                </div>

                <div class="card-body">
                    <table class="table">
                        <thead style="font-size: 20px;font-weight: bold; color: #000000">
                            <tr>
                                <th>Medico</th>
                                <th>Especialidad</th>
                                <th>Fecha</th>
                                <th>Hora</th>
                                <th>Paciente</th>
                                <th>Consulta</th>
                            </tr>
                        </thead>
                        <tbody style="font-size: 20px;color: #000000">
                            <tr>
                                <td>JOSE SOTO</td>
                                <td>Medicina General</td>
                                <td>25-01-2021</td>
                                <td>19:30</td>
                                <td>Gloria González</td>
                                <td><button class="btn btn-outline-primary"
                                            style="border-radius: 40px; font-size: 18px; color: #ffffff; font-weight: bold;"
                                            (click)="unirseReunion()">Unirse a la Consulta</button></td>
                            </tr>
                        </tbody>
                    </table>

                    <br><br>
                </div>

            </div>
        </div>
    </div>
</div> -->